module.exports = __webpack_public_path__ + "img/vue1-doublure_bleu.b4c93671.png";